const PROD_HMS_URL = 'https://hms.t4b.com/'
const DEV_HMS_URL = 'https://homedev.tfbdev.com/'

export const getResourceAddress = (originAddress: string) =>
    originAddress.includes('test') || originAddress.includes('dev')
        ? DEV_HMS_URL
        : PROD_HMS_URL